<!--
 * @Author: 李朋飞
 * @Date: 2021-07-12 16:14:29
 * @LastEditTime: 2021-07-21 15:35:17
 * @Description: 公共分页
-->
<template>
  <div class="l_pagination">
    <el-pagination
      @current-change="handleCurrentChange"
      :page-size="paginationParameter.pageSize"
      :current-page="paginationParameter.page"
      layout="total, prev, pager, next, jumper"
      :total="paginationParameter.total">
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    paginationParameter: {
      type: Object,
      default: () => {
        return (
          {
            pageSize: 20,
            page: 1,
            total: 0
          }
        )
      }
    }
  },
  methods: {
    handleCurrentChange(val) { // 返回当前的页数
      this.$emit('handleCurrentChange', val)
    }
  }
}
</script>
<style lang='scss'>
.l_pagination{
  width: 100%;
  height: 35px;
  margin-top: 20px;
  text-align: right;
  .el-pagination{
    font-size: 14px !important;
    color: #666666;
    .el-pagination__total{
      font-size: 14px !important;
      color: #666666;
    }
    .el-pagination__jump{
      font-size: 14px !important;
    }
    li{
      font-size: 14px !important;
      font-weight: normal;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Pagination/Pagination.vue